NtechApp.WorkingHoursItemsCollection = function($view) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._construct = function() {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();
        
        me._initGrid();
        me._bindEvents();
    }

    this._bindEvents = function () {
        me._click.listen(me._$view.find("[data-gridContent]"), "[data-itemValue]", function(e) {
            var $item = $(e.target).closest("[data-itemValue]");
            me.rmItem($item);
        });
    }

    this._bindAutoEvents = function() {
    }

    this._unbindEvents = function () {
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.WorkingHoursItemsCollection.EVENT_ITEM_RM = "NtechApp.WorkingHoursItemsCollection.EventItemRemove";

NtechApp.proto(NtechApp.WorkingHoursItemsCollection, {
    _initGrid: function() {
        var $initialState = this._$view.find("[data-initialGridState]");
        var dayShiftsData = [];

        $.each($initialState.find("[data-itemInitialValue]"), function() {
            dayShiftsData.push($(this).attr("data-itemInitialValue"));
        });

        $initialState.remove();
        this.renderGrid(dayShiftsData);
    },

    _hideGrid: function() {
        this._$view.css("display", "none");
    },

    _showGrid: function() {
        this._$view.css("display", "block");
    },

    _unpackDayShiftsData: function(dayShiftsData) {
        var unpackedDayShiftsData = [];
        for(var i = 0; i < dayShiftsData.length; i++) {
            var shiftData = dayShiftsData[i].split("|");
            
            var day = shiftData[0];
            var fromHoursData = shiftData[1].split("-");
            var toHoursData = shiftData[2].split("-");

            unpackedDayShiftsData.push({
                day: parseInt(day, 10),
                startTime: fromHoursData[0],
                startHour: parseInt(fromHoursData[0].split(":")[0], 10),
                startMinute: parseInt(fromHoursData[0].split(":")[1], 10),
                startPeriod: fromHoursData[1],
                endTime: toHoursData[0],
                endHour: parseInt(toHoursData[0].split(":")[0], 10),
                endMinute: parseInt(toHoursData[0].split(":")[1], 10),
                endPeriod: toHoursData[1],
                value: dayShiftsData[i]
            });
        }

        return unpackedDayShiftsData;
    },

    _sortDayShiftsData: function(dayShiftsData) {
        dayShiftsData.sort(function(first, second) {
            if(first.day > second.day) 
                return 1;
            
            if(first.day < second.day)
                return -1;

            if(first.endPeriod == "am" && second.startPeriod == "pm")
                return -1;

            if(first.endPeriod == "pm" && second.startPeriod == "am")
                return 1;

            if(first.endPeriod == second.endPeriod) {
                if(first.endHour > second.endHour)
                    return 1;

                if(first.endHour < second.endHour)
                    return -1;

                return first.endMinute - second.endMinute;
            }
        });

        return dayShiftsData;
    },

    getDayByIndex: function(data) {
        var days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        return days[data.day];
    },

    getTimeShift: function(data) {
        var msg = "";
        
        msg += data.startTime + " " + data.startPeriod + " - ";
        msg += data.endTime + " " + data.endPeriod;

        return msg;
    },

    renderGrid: function(dayShiftsData) { 
        var dayShiftsData = dayShiftsData || [];
        var $existingItems = this._$view.find("[data-gridContent] [data-itemValue]");
        
        $.each($existingItems, function() {
            dayShiftsData.push($(this).attr("data-itemValue"));
        });
        $existingItems.remove();
        
        dayShiftsData = this._unpackDayShiftsData(dayShiftsData);
        dayShiftsData = this._sortDayShiftsData(dayShiftsData);

        var gridHtml = "";
        for(var i = 0; i < dayShiftsData.length; i++) {
            var gridItemHtml = "";
            var data = dayShiftsData[i];

            var day = this.getDayByIndex(data);
            var timeShift = this.getTimeShift(data);

            gridItemHtml += '<div class="gridItem" data-itemValue="' + data.value + '">';
            gridItemHtml += '   <div class="content">';
            gridItemHtml += '       ' + day + ': <span class="highlight">' + timeShift + '</span>';
            gridItemHtml += '       <span class="rmControl"></span>';
            gridItemHtml += '   </div>';
            gridItemHtml += '</div>';

            gridHtml += gridItemHtml;
        }

        this._$view.find("[data-gridContent]").append($.parseHTML(gridHtml));

        if(dayShiftsData.length == 0)
            this._hideGrid();
        else
            this._showGrid();
    },

    rmItem: function($item) {
        var me = this;

        NtechApp.confirmForm.load(function() {
            $item.remove();
            me.renderGrid();

            NtechApp.confirmForm.unload();
            $(me).trigger(NtechApp.WorkingHoursItemsCollection.EVENT_ITEM_RM);
        });
    },

    getPackedWorkingHours: function() {
        var $existingItems = this._$view.find("[data-gridContent] [data-itemValue]");
        var shiftsData = [];

        $.each($existingItems, function() {
            shiftsData.push($(this).attr("data-itemValue"));
        });

        return shiftsData.join(";");
    }
});